import { createApp } from 'vue'
import App from '@/App.vue'
import '@/assets/theme.css'
import 'mapbox-gl/dist/mapbox-gl.css'

createApp(App).mount('#app')
